var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from "mobx";
import { RetrieverChooser } from "./RetrieverChooser";
var Retriever = /** @class */ (function () {
    function Retriever(bff, dataProvider, deviceChangeDispatcherMock) {
        this.leagues = [];
        this.retrieverChooser = new RetrieverChooser(bff, dataProvider, this.updateLeagues);
        this.isLoading = false;
        this.deviceChangeDispatcherMock = deviceChangeDispatcherMock;
    }
    Retriever.prototype.setRegionId = function (regionId) {
        this.leaguesRetriever.setRegionIds(regionId);
    };
    Retriever.prototype.removeRegionId = function () {
        this.leaguesRetriever.removeRegionId();
    };
    Retriever.prototype.activate = function () {
        this.clearData();
        this.deviceChangeDispatcherMock && this.deviceChangeDispatcherMock.activate();
    };
    Retriever.prototype.selectRetriever = function (sportId, leagueIds) {
        this.isLoading = true;
        this.leaguesRetriever = this.retrieverChooser.selectRetriever(sportId, leagueIds);
        this.leaguesRetriever.loadData();
    };
    Retriever.prototype.updateLeagues = function (leagues) {
        this.isLoading = false;
        this.leagues = leagues;
    };
    Retriever.prototype.clearData = function () {
        this.leagues = observable([]);
    };
    Retriever.prototype.deactivate = function () {
        this.clearData();
        this.deviceChangeDispatcherMock && this.deviceChangeDispatcherMock.deactivate();
    };
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], Retriever.prototype, "leagues", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], Retriever.prototype, "isLoading", void 0);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Retriever.prototype, "updateLeagues", null);
    return Retriever;
}());
export { Retriever };
//# sourceMappingURL=Retriever.js.map